import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
    mappingMasterList : []
};

export default function (state = initialState, action) {
    //console.log(action);
    switch (action.type) {
        case actionTypes.STORE_MAPPING_MASTER_LIST: 
        return {...state,mappingMasterList : action.val};
        default:
          break;
    }
    return state;
}